'use client'

import Image from 'next/image'

import { ZAPDetailButton } from '@/app/[locale]/annual-programs/_components/ap-detail'
import { useAPDetailGenderSelection } from '@/app/[locale]/annual-programs/_hooks'

/**
 * Description sections for Medante Balance annual program.
 * Displays program features including:
 * - Overview of program benefits
 * - 10% discount on specialist visits
 * - 10% discount on dental treatments
 * - Year-round GP care
 * - Gender selection buttons
 *
 * @example
 * ```typescript
 * <AMBDescription />
 * ```
 */
export default function AMBDescription() {
	const handleClick = useAPDetailGenderSelection()

	return (
		<>
			{/* Program Overview */}
			<section className='medante-vital__description wrapper2 mgt-30lg mgt-80 mgb-60 mgb-20lg'>
				<div className='medante-vital__description_content'>
					<p>
						Ročný program Medante Balance je prispôsobený potrebám{' '}
						<b>dospelých, detí aj rodín.</b> K tomu pridávame možnosť ročnej
						starostlivosti špecializovaných ambulancií pre zdravie a jeho udržanie počas
						celého roka.
					</p>
				</div>
			</section>

			{/* Specialist Visits Discount */}
			<section className='medante-vital__description mgt-20lg mgt-60 mgb-20lg mgb-60'>
				<div className='wrapper2 medante-vital__description_content'>
					<h2>
						<b>10% zľava pri návšteve</b>
						<br />
						špecialistov Polikliniky Medante
					</h2>
					<p>
						S ročným programom Medante Balance máte na{' '}
						<b>všetky návštevy špecialistov Polikliniky Medante zľavu 10%.</b>
					</p>

					<ul>
						<li>Vstupné vyšetrenia</li>
						<li>Kontroly zdravotného stavu</li>
						<li>Dispenzárna starostlivosť</li>
					</ul>

					<p>Darujte si nadštandardnú starostlivosť o vaše zdravie už dnes.</p>
				</div>

				<img
					className='medante-vital__description_illustration'
					src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/illustrations/long-wave/long-medante-wave-sand-02.svg`}
					alt='Ilustračná vlnka'
				/>
			</section>

			{/* Dental Services Discount */}
			<section className='medante-vital__description wrapper2  mgt-20lg mgt-60 mgb-20lg mgb-20'>
				<div className='medante-vital__description_content column'>
					<h2>
						<b>10% zľava na ošetrenia</b>
						<br />v stomatologickej ambulancii{' '}
					</h2>
					<p>
						S ročným programom Medante Balance máte ešte lacnejšie{' '}
						<b>stomatologické ošetrenia ako:</b>
					</p>

					<ul>
						<li>Ošetrenia zubných kazov</li>
						<li>Výplne koreňových kanálikov</li>
						<li>Extrakcie zubov</li>
					</ul>

					<p>
						Zvýhodnená cena sa nevzťahuje na protetiku, implantáty a dentálnu hygienu.
					</p>
				</div>

				<div className='medante-vital__description_images column'>
					{/* TODO: V priebehu septembra pošlú nové fotografie, tak ich potom nahradime za
					tieto */}
					{/* <Image
						unoptimized={true}
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/annual-programs/lekarky-1.webp`}
						alt='Stomatologické ošetrenia'
						height={170}
						width={325}
						className='col-span-1'
					/>
					<Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/annual-programs/lekarky-2.webp`}
						unoptimized={true}
						alt='Stomatologické ošetrenia'
						height={170}
						width={325}
						className='col-span-1'
					/> */}
					<Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/annual-programs/stomatologicka-ambulancia.webp`}
						unoptimized={true}
						alt='Stomatologické ošetrenia'
						height={170}
						width={670}
						className='col-span-2'
					/>
				</div>
			</section>

			{/* GP Care */}
			<section className='medante-vital__description wrapper2  mgt-20lg mgt-20 mgb-20lg mgb-60'>
				<div className='medante-vital__description_content'>
					<h2>
						<b>Celoročná starostlivosť</b>
						<br />u všeobecného lekára{' '}
					</h2>
					<p>
						Zverte svoje zdravie lekárovi, ktorému na vás záleží. S ročným programom
						Medante Balance získate:
					</p>

					<ul>
						<li>Akútne termíny do 24 hodín</li>
						<li>Starostlivosť s ohľadom na vaše potreby</li>
						<li>Služby klientskeho centra - osobne, telefonicky či emailom</li>
					</ul>

					<div className='medante-vital__description__buttons'>
						<ZAPDetailButton
							text='Program pre ženu'
							onClick={() => handleClick('female')}
							isPrimary={true}
							color='cyclamen'
						/>

						<ZAPDetailButton
							text='Program pre muža'
							onClick={() => handleClick('male')}
							isPrimary={true}
							color='blue'
						/>
					</div>
				</div>
			</section>
		</>
	)
}
